import React from 'react';

type Props = {
  attribute?: string[] | null;
};

export const FileAttribute: React.FC<Props> = ({ attribute }) => {
  return (
    <>
      {attribute?.map((value, i) => (
        <div data-id="fileAttr" key={i}>
          <a href={value} target="_blank" rel="noreferrer">
            {value}
          </a>
        </div>
      ))}
    </>
  );
};
